<template>
    <div id="top-par" class="layui-header my-layui-header" >
        <!-- 头部区域 -->
        <ul class="layui-nav layui-layout-left">
            <li class="layui-nav-item layadmin-flexible" id="top-bar-flexible"
            @mouseover="leftItemMouseOver('top-bar-flexible')"
            @mouseout="leftItemMouseOut('top-bar-flexible')">
                <a href="javascript:;"  title="侧边伸缩" @click="sideShrink()">
                  <i class="layui-icon layui-icon-shrink-right " :class="{'layui-icon-spread-left' : $store.state.style.sideShrink}"></i>
                </a>
            </li>
            
            <span class="layui-nav-bar" 
            :style="{ left: leftBarLeft + 'px', width: leftBarWidth + 'px', opacity: leftBarOpacity}"></span>
        </ul>
        <ul class="layui-nav layui-layout-right" >

            <li class="layui-nav-item layui-hide-xs" id="top-bar-theme"
            @mouseover="rightItemMouseOver('top-bar-theme')"
            @mouseout="rightItemMouseOut('top-bar-theme')"
            @click="popTheme('top-bar-theme')">
                <a href="javascript:;" >
                    <i class="layui-icon layui-icon-theme"></i>
                </a>
            </li>

            <li class="layui-nav-item layui-hide-xs" id="top-bar-fullscreen"
            @mouseover="rightItemMouseOver('top-bar-fullscreen')"
            @mouseout="rightItemMouseOut('top-bar-fullscreen')"
            @click="handleFullScreen()">
                <a href="javascript:;" >
                    <i class="layui-icon layui-icon-screen-full"></i>
                </a>
            </li>

            <li class="layui-nav-item layui-hide-xs" id="top-bar-user" 
            @mouseover="rightItemMouseOver('top-bar-user')"
            @mouseout="rightItemMouseOut('top-bar-user')"
            @click="upbit = !upbit">
                <a href="javascript:;">
                    <img src="./../../assets/cafe.gif" class="layui-nav-img">{{ nickName }}
                    <span class="layui-nav-more " :class="{'layui-nav-mored':upbit}"></span>
                </a>

                <dl class="layui-nav-child layui-anim layui-anim-upbit my-panel " :class="{'layui-show':upbit}">
                    <dd @click="handleCommand('toPersonalCenter')" ><!-- v-if="hasAuthority('personalCenter')" -->
                        <a href="javascript:;"><i class="fa fa-user"></i>
                        个人中心</a>
                    </dd>
                    <hr>
                    <dd @click="handleCommand('logout')">
                        <a href="javascript:;"><i class="fa fa-sign-out"></i> 退出</a>
                    </dd>
                </dl>
                
            </li>
              


            <li class="layui-nav-item layui-show-xs-inline-block layui-hide-sm" id="top-bar-more" @click="sm_upbit = !sm_upbit">
                <a href="javascript:;" >
                    <i class="layui-icon layui-icon-more-vertical"></i>
                </a>
                <dl class="layui-nav-child layui-anim layui-anim-upbit my-panel " :class="{'layui-show':sm_upbit}">
                    <hr>
                    <dd @click="handleCommand('logout')">
                        <a href="javascript:;"><i class="fa fa-sign-out"></i> 退出</a>
                    </dd>
                </dl>
            </li>

            <span class="layui-nav-bar" 
            :style="{ left: rightBarLeft + 'px', width: rightBarWidth + 'px', opacity: rightBarOpacity}"></span>
        </ul>


    </div>
        
</template>


<script>
import {getUserInfo, modifyPwd} from '@/api/user.js'
import {agentHomeNotify, agentHomeNotifyReaded} from '@/api/system.js'
import common from '@/utils/common.js'
import { mapGetters, mapMutations } from "vuex";
export default {
    data(){
        

        return {
            nickName: '',
            accountName: '',
           

            //顶部左侧菜单
            leftBarLeft: 0,
            leftBarWidth: 0,
            leftBarOpacity: 0,
            //顶部右侧菜单
            rightBarLeft: 0,
            rightBarWidth: 0,
            rightBarOpacity: 0,
            //全屏状态
            fullscreen: false,
            //显示修改密码菜单栏
            upbit: false,

            sm_upbit: false,

            oneNotify: '',
            notifyId: '',

        }
    },
    methods: {
        ...mapGetters("menu", {
            getNickName: "getNickName",
        }),
        ...mapMutations('menu', {
            addTab: 'addTab',
            switchTab: 'switchTab'
        }),
        handleCommand(command){
            switch (command) {
                case 'logout':
                    this.logoutHandler();
                    break;
                case 'toPersonalCenter':
                    this.toPersonalCenter();
                    break;
                    
                default:
                    break;
            }
        },

        toPersonalCenter(){
            if (!this.$store.state.menu.isPersonalCenterTab) {
                let newTab = {
                    label: '个人中心',
                    index: 'personalCenter',
                    closable: true,
                    component: "views/statistics/personalCenter"
                }
                this.$store.commit('menu/addTab', newTab);
                this.$store.commit('menu/setIsPersonalCenterTab', true);
            }
            this.$store.commit('menu/switchTab', 'personalCenter')
        },


        logoutHandler(){
            if(this.oneNotify){
                this.oneNotify.close();
            } 
            var menuState = this.$store.state.menu;
            for(var key in menuState){
                switch (typeof(menuState[key])) {
                    case 'string':
                        menuState[key] = ''
                        break;
                    case 'object':
                        menuState[key] = []
                        break;
                    default:
                        break;
                }
            }

            let loginAccounts = localStorage.getItem('loginAccounts');//记住账号
            localStorage.clear();
            if(loginAccounts!=null && loginAccounts!=undefined && loginAccounts.length > 0){
                this.setAutoCompleteData("loginAccounts",loginAccounts);
            }
            
            this.$store.commit('menu/setIsPersonalCenterTab', false);
            this.$router.push('/');
        },
        getAgentNotify(data){
            if(sessionStorage.getItem("isCollect")==1){
                return;
            }
            agentHomeNotify(data).then(res => {
                if(res.data.code == 200){
                    this.notifyId = res.data.data.id;
                    const h = this.$createElement;
                    this.oneNotify = this.$notify({
                        title: res.data.data.title,
                        dangerouslyUseHTMLString: true,
                        message: h('div', null, [
                                    h('div', null, [
                                        h('span', {style: 'font-size: 12px'}, `${res.data.data.currentTime}`),
                                        h('el-checkbox', {
                                            style: 'float: right',
                                            on: {
                                                change: this.notifyReadedHandler
                                            } 
                                        }, '已读')
                                    ]),
                                    h('div', {
                                        domProps: {
                                            'innerHTML': `${res.data.data.content.replace(/\n/g, '<br>')}` 
                                        }
                                    })
                                ]),
                        position: 'bottom-right',
                        duration: 0
                    })
                }
            })
        },
        notifyReadedHandler(){
            var data = {
                id: this.notifyId,
                accountName: this.accountName
            }
            agentHomeNotifyReaded(data)
        },
        //收起左侧菜单栏
        sideShrink(){
            let w = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;

            let h = window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;


            if(this.$store.state.style.sideShrink){
                this.$store.commit('style/setSideShrink', false);
            }else{
                this.$store.commit('style/setSideShrink', true);
                //收起子菜单
                this.$store.commit('menu/setActiveItem', '0');
            }

        },

        //顶部左侧菜单鼠标进入
        leftItemMouseOver(id){
            this.leftBarLeft = document.getElementById(id).offsetLeft;
            this.leftBarWidth = document.getElementById(id).offsetWidth;
            this.leftBarOpacity = 1;
        },
        //顶部左侧菜单鼠标移出
        leftItemMouseOut(id){
            this.leftBarWidth = document.getElementById(id).offsetWidth;
            this.leftBarOpacity = 0;
            this.leftBarLeft = document.getElementById(id).offsetLeft;
        },

        //顶部右侧菜单鼠标进入
        rightItemMouseOver(id){
            this.rightBarLeft = document.getElementById(id).offsetLeft;
            this.rightBarWidth = document.getElementById(id).offsetWidth;
            this.rightBarOpacity = 1;
        },
        //顶部又侧菜单鼠标移出
        rightItemMouseOut(id){
            this.rightBarWidth = document.getElementById(id).offsetWidth;
            this.rightBarOpacity = 0;
            this.rightBarLeft = document.getElementById(id).offsetLeft;
        },

        //主题面板显隐切换
        popTheme(){
            let ele = document.getElementById('LAY_adminPopupTheme');
            var w = ele.style.width;
            if(w==null || w=='' || w== '0px'){
                ele.style.width ="320px";
            }else{
                ele.style.width ="0px";
            }
        },
        

        // 全屏事件
        handleFullScreen(){
            let element = document.documentElement;
            // 判断是否已经是全屏
            // 如果是全屏，退出
            if (this.fullscreen) {
                if (document.fullscreenElement) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {    // 否则，进入全屏
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            // 改变当前全屏状态
            this.fullscreen = !this.fullscreen;
        }
    },
    created(){
        var data = {
            id: localStorage.getItem('id')
        }
        getUserInfo(data).then(res => {
            if(res.data.code == 200){
                var result = res.data.data;                
                this.nickName = result.nickName;
                this.accountName = result.accountName;
                var loginSysRoleVoList = result.loginSysRoleVoList;
                loginSysRoleVoList.forEach(item => {
                    if(item.id == 100){
                        var data = {
                            accountName: result.accountName
                        }
                        this.getAgentNotify(data);
                    }
                }); 

                var firstList = result.loginSysMenuVoList[0].nextLoginMenuVoList[0];
                var tab = this.$store.state.menu.tabs.find(f => f.index == firstList.id)
                if(!tab){
                    var newTab = {
                        label: firstList.name,
                        index: firstList.id,
                        component: 'views/' + firstList.path
                    }
                    this.addTab(newTab)
                }
                this.switchTab(firstList.id)
            }else{
                this.$message.error(res.data.message)
            }
        })
    },

    mounted(){

    },

    computed: {
        ...mapGetters("menu", {
            hasAuthority: "hasAuthority" 
        }),

    },

    
};
</script>

<style lang="less" scoped>

.layadmin-tabspage-none{
    *{
        transition: all .3s;
    }
}

.layadmin-view-xs.layadmin-side-shrink{
    *{
        transition: all .3s;
    }

    .layui-layout-left{
        left: 45px;
    }
}

.layadmin-view-sm{
    .layui-layout-right{
        right: -100px;
    }
}


.layadmin-view-sm.layadmin-side-shrink{
    *{
        transition: all .3s;
    }

    .layui-layout-left{
        left: 0px;
    }

    .layui-layout-right{
        right: 0px;
    }
}

.my-layui-header{
    z-index:1002;
    .my-panel{
        position: absolute;
        z-index:1002;
    }
}

</style>
